import * as Sentry from "@sentry/react";
import { SENTRY_DSN, scrubSentryEvent } from "../../../shared/sentry";
const apiOrigin = (() => { try { return new URL(import.meta.env.VITE_API_URL).origin; } catch { return ""; } })();
export function initSentry() {
  if (Sentry.getClient()) return;
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN || SENTRY_DSN,
    enabled: import.meta.env.VITE_SENTRY_ENABLED === "true" || (import.meta.env.PROD && import.meta.env.VITE_SENTRY_ENABLED !== "false"),
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
    // Uncaught errors and unhandled rejections are on by default; console.error
    // adds the failures the app catches and logs itself, so they aren't only
    // discovered when a user reports them.
    integrations: [Sentry.browserTracingIntegration(), Sentry.captureConsoleIntegration({ levels: ["error"] })],
    tracePropagationTargets: [/^\/api(?:\/|$)/, ...(apiOrigin ? [new RegExp("^" + apiOrigin.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "/")] : [])],
    beforeSend: scrubSentryEvent,
    beforeSendTransaction: scrubSentryEvent,
  });
}
const captured = new WeakSet<object>();
export function reportClientError(error: unknown, boundary: string) {
  if (typeof error === "object" && error !== null) {
    if (captured.has(error)) return;
    captured.add(error);
    const status = (error as { status?: number }).status;
    if (status && status >= 400 && status < 500) return;
  }
  Sentry.captureException(error instanceof Error ? error : new Error("React route failed"), { tags: { runtime: "browser", boundary } });
}
initSentry();
export { Sentry };
